"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignSelf: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1)
}));
